import { createFileRoute } from '@tanstack/react-router';

import { DiagramEmbedPage } from '@/pages/diagram-embed/diagram-embed-page';

export const Route = createFileRoute('/embed/diagram/$diagramId')({
    component: DiagramEmbedRoute,
    staticData: { chromeless: true },
});

function DiagramEmbedRoute() {
    const { diagramId } = Route.useParams();
    return <DiagramEmbedPage diagramId={diagramId} />;
}
